import React, {FC} from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import DescriptionIcon from '@mui/icons-material/Description';

import Panel from '@/components/Panels/common/Panel';
import DocumentItem from '@/components/Panels/Parcel/Documentation/DocumentItem';

import {PANEL_WIDTH} from '@/config';

import {useTranslation} from 'react-i18next';

import {SelectedParcelMode} from '@/components/Panels/Parcel';
import {DocumentationMode} from '@/components/Panels/Parcel/Documentation/index';
import AddButton from '@/components/AddButton';
import {DocumentProperties} from '@/domain/entities/ParcelDocument';

//TYPES
export type DocumentsListPanelProps = {
  documents?: Array<DocumentProperties>,
  onSelectedParcelModeChanged: (selectedParcelMode: SelectedParcelMode) => void,
  onDocumentDownload: (dataUrl: string, name: string) => void,
  onDocumentDelete: (uuid: string) => void,
  onDocumentationModeChanged: (documentationMode: DocumentationMode) => void
};

const DocumentsListPanel: FC<DocumentsListPanelProps> = ({documents=[], onDocumentDownload, onDocumentDelete, onSelectedParcelModeChanged, onDocumentationModeChanged}) => {
  
  const {t} = useTranslation();

  const handleExit = () => onSelectedParcelModeChanged(SelectedParcelMode.INFO);
  const handleAddDocumentOpen = () => onDocumentationModeChanged(DocumentationMode.ADD);

  return <Panel width={PANEL_WIDTH.documentList}>
    <Stack direction="column">
      <Stack direction="row" sx={{alignItems: 'center', gap: 1, mb: 2}}>
        <DescriptionIcon sx={{fontSize: '28px', color: 'primary.main'}}/>
        <Typography variant="h6" sx={{color: 'primary.main', m: 0, p: 0}}>{t('documentsPanel.title')}</Typography>
      </Stack>
    </Stack>
    {
      documents.length > 0 
        ? documents?.map(document =>
          <DocumentItem key={document.uuid} document={document} onDownload={onDocumentDownload} onDelete={onDocumentDelete}/>)
        : <Typography>{t('documentsPanel.withoutDocuments')}</Typography>
    }
    <Stack direction="row" sx={{gap: 2, alignItems: 'center', justifyContent: 'space-between', mt: 2}}>
      <Button variant="outlined" startIcon={<CancelPresentationIcon/>} sx={styles.smallButton} onClick={handleExit}>
        {t('documentsPanel.exit')}
      </Button>
      <AddButton onClick={handleAddDocumentOpen} disabled={false}/>
    </Stack>
  </Panel>;
};
export default DocumentsListPanel;

const styles = {
  smallButton: {
    width: '150px',
    alignSelf: 'flex-end'
  }
};
